module.exports = __webpack_public_path__ + "img/inner-2.c5d8ddb6.png";